import { Loader } from "lucide-react";

function LoadingModal() {
	return (
		<div className='absolute z-50 top-0 left-0 bg-black/10 h-screen w-screen flex flex-row justify-center items-center visible'>
			<div
				className='w-fit min-h-fit bg-white rounded-2xl p-8'
				onClick={(e) => e.stopPropagation()}
			>
				<Loader className='animate-spin text-primary min-h-8 min-w-8 text-themeColor' />
			</div>
		</div>
	);
}

export default LoadingModal;
